import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_franquia/franquia-analise-comparacao-periodos";

export const Route = createFileRoute("/_authenticated/franquia-analise-comparacao-periodos")({
  head: () => ({
    meta: [
      { title: "Comparação por períodos — Milky Moo Palmares" },
      {
        name: "description",
        content: "Compare valores de vendas e principais produtos entre dois períodos.",
      },
    ],
  }),
  component: PaginaRota,
});
